import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mc2013',
    ecrans: ['00-2'],
    params: ['id']
});
